<template>
    <v-container fluid>
        <modal-form-documento
            ref="ModalFormDocumento"
            @salvarDados="salvarDados"
        />

        <listagem-documentos
            ref="ListagemDocumentos"
            :documentos="documentos"
            :loading="loadingDocumentos"
            :desabilitaAlturaMaxima="desabilitaAlturaMaxima"
            @atualizarListagem="buscarListaDocumentos"
            @baixar="lidarBaixarDocumento"
            @excluir="lidarExcluirDocumento"
            @novoDocumento="novoDocumento"
        />
    </v-container>
</template>

<script>
    import { mapActions } from 'vuex'
    import actionTypes from '@/core/constants/action-types'
    import ListagemDocumentos from './ListagemDocumentos'
    import ModalFormDocumento from './ModalFormDocumento'

    const TIPOS_DONO_DOCUMENTO = Object.freeze({
        patrimonio: 'patrimonio',
        movimentacao: 'movimentacao',
        reavaliacao: 'reavaliacao',
        ajuste: 'ajuste'
    })

    export default {
        name: 'Documentos',

        components: {
            ListagemDocumentos,
            ModalFormDocumento,
        },

        data() {
            return {
                documentos: [],
                loadingDocumentos: false,
            }
        },

        props: {
            donoDocumento: {
                type: String,
                required: true
            },
            donoDocumentoId: {
                required: true
            },
            desabilitaAlturaMaxima: {
                type: Boolean,
                required: false,
                default: false,
            },
        },

        watch: {
            documentos() {
                this.$emit('updateNumeroDeDocumentos', this.documentos.length)
            }
        },

        async mounted() {
            await this.buscarListaDocumentos()
        },

        methods: {
            ...mapActions({
                buscarDocumentos: actionTypes.DOCUMENTO.BUSCAR_DOCUMENTOS,
                enviarDocumento: actionTypes.DOCUMENTO.ENVIAR_DOCUMENTO,
                deletarDocumento: actionTypes.DOCUMENTO.DELETAR_DOCUMENTO,
                baixarDocumento: actionTypes.DOCUMENTO.BAIXAR_DOCUMENTO,
                baixarMemorandoPatrimonio: actionTypes.RELATORIO.BAIXAR_RELATORIO_MEMORANDO_PDF,
                baixarMemorandoMovimentacao: actionTypes.RELATORIO.BAIXAR_RELATORIO_MEMORANDO_MOVIMENTACAO_PDF,
                baixarMemorandoReavaliacao: actionTypes.RELATORIO.BAIXAR_RELATORIO_MEMORANDO_REAVALIACAO_PDF,
                baixarMemorandoAjuste: actionTypes.RELATORIO.BAIXAR_RELATORIO_MEMORANDO_AJUSTE_PDF,
            }),
            quantidadeDeDocumentosExcedida() {
                return this.documentos.length >= 30
            },
            podeCriarNovoDocumento() {
                if (this.quantidadeDeDocumentosExcedida()) {
                    this.mostrarNotificacaoErro('A quantidade máxima de documentos cadastrados foi atingida.')
                    return false
                }
                return true
            },
            novoDocumento() {
                if (!this.podeCriarNovoDocumento()) return

                this.$refs.ModalFormDocumento.abrirModal()
            },
            async buscarListaDocumentos() {
                this.loadingDocumentos = true
                const params = `${this.donoDocumento}Id=${this.donoDocumentoId}`
                const documentos = await this.buscarDocumentos(params)
                if (!this.existeDocumentoReservado(documentos)) {
                    const docReservado = this.gerarDadosDocumentoReservado()
                    documentos.push(docReservado)
                }
                this.documentos = documentos
                this.loadingDocumentos = false
            },
            async salvarDados(documento) {
                this.desabilitarLoadingGlobal()

                const payload = {
                    ...documento,
                    [this.donoDocumento]: this.donoDocumentoId
                }

                await this.enviarDocumento(payload)

                this.$refs.ModalFormDocumento.fecharModal()

                await this.buscarListaDocumentos()
                this.habilitarLoadingGlobal()
            },
            async baixarDocumentoReservado(documento) {
                const methods = {
                    [TIPOS_DONO_DOCUMENTO.movimentacao]: (doc) => this.baixarMemorandoMovimentacao(doc.movimentacao),
                    [TIPOS_DONO_DOCUMENTO.patrimonio]: (doc) => this.baixarMemorandoPatrimonio(doc.patrimonio),
                    [TIPOS_DONO_DOCUMENTO.reavaliacao]: (doc) => this.baixarMemorandoReavaliacao(doc.reavaliacao),
                    [TIPOS_DONO_DOCUMENTO.ajuste]: (doc) => this.baixarMemorandoAjuste(doc.ajuste),
                }
                if (methods[this.donoDocumento]) {
                    await methods[this.donoDocumento](documento)
                    await this.buscarListaDocumentos()
                }
            },
            async lidarBaixarDocumento(documento) {
                if (!documento.id || (documento.documentoReservado && documento.isEmElaboracao)) {
                    await this.baixarDocumentoReservado(documento)
                } else {
                    await this.baixarDocumento(documento)
                }
            },
            async lidarExcluirDocumento(documento) {
                await this.deletarDocumento(documento.id)
                await this.buscarListaDocumentos()
            },
            existeDocumentoReservado(documentos) {
                return documentos.some(doc => doc.documentoReservado === true)
            },
            gerarDadosDocumentoReservado() {
                return {
                    titulo: 'Memorando',
                    tipoDescricao: 'Memorando',
                    dataCadastro: '',
                    documentoReservado: true,
                    usuarioCadastro: 'JobSystem',
                    [this.donoDocumento]: this.donoDocumentoId
                }
            },
        }
    }
</script>
